import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=df1577d0&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=js&"
export * from "./submitOrder.vue?vue&type=script&lang=js&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=df1577d0&lang=less&scoped=true&"
import style1 from "./submitOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1577d0",
  null
  
)

export default component.exports